<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <h2>
        SZTUKA, ORYGINALNOŚĆ I SZALEŃSTWO KOLORÓW Z TEJ KOLEKCJI SPRAWIAJĄ, ŻE
        BEZ WĄTPIENIA SĄ TO PODŁOGI DLA ODWAŻNYCH, IDEALNIE WPASUJĄ SIĘ W
        NIECODZIENNE PROJEKTY.
      </h2>
      <p>
        Atrakcyjne wnętrze to nie tylko meble i ozdoby. Aby urządzić swoje
        cztery kąty w taki sposób, by zachwycały każdego gościa, należy skupić
        się przede wszystkim na rozwiązaniach wysokiej jakości, które pozwolą na
        bezproblemowe użytkowanie przez wiele lat bez konieczności wymieniania
        ich na nowsze. Oferowane przez nas podłogi dekoracyjne z prezentowanej
        poniżej kolekcji cechują się niezwykłymi walorami estetycznymi, a upływ
        czasu sprawia, że nasze posadzki stają się jeszcze atrakcyjniejsze i
        zyskują niepowtarzalny charakter. Podłogi znajdujące się w naszej
        ofercie wykonane zostały z prawdziwego drewna, które pozwala stworzyć w
        domu przytulną, kameralną atmosferę. Dodatkowo, obcowanie z naturalnymi
        materiałami bardzo dobrze wpływa na samopoczucie. Dzięki przedstawianej
        tu szerokiej gamie kolorystycznej, nasze posadzki dekoracyjne na pewno
        pozwolą Państwu stworzyć we własnym wnętrzu pożądany efekt. Kolekcja
        desek stworzonych dla osób o odważnym guście, którzy nie boją się
        oryginalnych wnętrz. Każda deska malowana ręcznie, często w sposób
        daleko odbiegającym od klasycznego, co daje efekt niepowtarzalnego
        wzoru. Kolory są nietuzinkowe, podłogi opalane żywym ogniem i wiele
        innych. Idealnie wpasowują się w obecny trend mieszkań w stylu „loft”
        oraz industrialnym.
      </p>
    </div>
    <div v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.src || image.thumb" @click="openGallery(index)" />
      <h3>{{ image.caption }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Images from "./nobilium.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: Images
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  box-shadow: 0 0 16px rgb(32, 28, 28);
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;

  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
